module.exports = __webpack_public_path__ + "static/img/533_phase_function_Paper_PointsHejduk_Prediction.4fd036d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/533_phase_function_Paper_PointsHejduk_Prediction.png
// module id = CDUK
// module chunks = 0